import React, {useContext} from "react";
import styled from "@emotion/styled";
import {Link} from "react-router-dom";

import firebase from "firebase/app";
import {UserContext} from "../../contexts/user";
import {ProfileTippy} from "../styled/Tippy";
import {Bars} from "@/components/icons";
import {getInternalPath} from "../../utils/url";

const ProfileMenu = ({categories}) => {
  const {user, userDispatch, logout} = useContext(UserContext);

  return (
    <ul>
      {user.isAdmin && (
        <span>
          <li>
            <Link to="/admin">ADMIN</Link>
          </li>
        </span>
      )}
      {user.isEditor && (
        <span>
          <li>
            <Link to="/editor">EDITORS</Link>
          </li>
        </span>
      )}
      {categories.map((category, idx) => {
        const internalPath = getInternalPath(category.href);
        const isInternal = !!internalPath;
        const targetHref = internalPath || category.href;

        return (
          <span key={idx}>
            {category.text === "BRAND" ? (
              <>
                {user.isBrand && (
                  <li>
                    {isInternal ? (
                      <Link to={targetHref}>{category.text}</Link>
                    ) : (
                      <a href={category.href}>{category.text}</a>
                    )}
                  </li>
                )}
              </>
            ) : (
              <li>
                {isInternal ? (
                  <Link to={targetHref}>{category.text}</Link>
                ) : (
                  <a href={category.href}>{category.text}</a>
                )}
              </li>
            )}
          </span>
        );
      })}
    </ul>
  );
};

const MobileMenu = ({categories}) => {
  return (
    <ProfileTippy content={<ProfileMenu categories={categories} />} interactive={true}>
      <a className="profile" href="#">
        <Bars />
      </a>
    </ProfileTippy>
  );
};

export default MobileMenu;
